// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07116eb1","732":"4e41ec78","977":"c208311b"}[chunkId] + ".chunk.js";
};